import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=7d635925&scoped=true&"
import script from "./SpinnerLoader.vue?vue&type=script&lang=ts&"
export * from "./SpinnerLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&id=7d635925&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d635925",
  null
  
)

export default component.exports